import React from "react";
import { RouteComponentProps } from "react-router";
import { AttentionDayDetail } from "../components/attentionday/AttentionDayDetail";

export function AttentionDaysDetailView({ match }: RouteComponentProps<{ id: string }>) {
    return (
        <div className="view detail view-attentiondays-detail">
            <AttentionDayDetail attentionDayId={match.params.id}></AttentionDayDetail>
        </div>
    );
}
